module.exports = __webpack_public_path__ + "img/Menu-11.ae468a25.png";